export default __webpack_public_path__ + "static/media/BrainBreak cards93.48bc2001.png";